import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "live-now-page"
};
const _hoisted_2 = {
  class: "page-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_StreamList = _resolveComponent("StreamList");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
    class: "page-header"
  }, [_createElementVNode("h1", null, "Live Now"), _createElementVNode("p", null, "Watch livestreams and premieres happening now.")], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_StreamList, {
    showNoResults: true,
    showloading: true
  })])]);
}